import { deleteCapacityFilter } from '@dispatch/shared/services';
import { useMutation } from 'react-query';

export const useDeleteCapacityFilter = (
  userId: string,
  onSuccess: () => void
) => {
  const { mutate, error, status } = useMutation(
    ['delete-capacity-filter', userId],
    async (filterId: string) => deleteCapacityFilter(userId, filterId),
    {
      onSuccess,
    }
  );

  return {
    deleteCapacityFilter: mutate,
    error,
    status,
  };
};
